import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ExternalGenDocHdrDriverLinkContainerModel } from "../../../../../../models";
import { BaseApiTemplateService, Core2Config,ApiVisa, Pagination, PagingResponseModel} from "../../shared";


@Injectable({ providedIn: "root" })
export class ExternalGenericDocHdrDriverLinkService extends BaseApiTemplateService<ExternalGenDocHdrDriverLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "xtn/gen-doc/driver-links/backoffice-ep";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX +  Core2Config.ERP_PREFIX + "xtn/gen-doc/driver-links/backoffice-ep";
    this.httpClient = http;
  }

  getDriverExternalGenericDocHdrDriverLinks(visa: ApiVisa){
      const apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX  + 'xtn/gen-doc/driver-links/driver-ep';
      return this.httpClient.get<PagingResponseModel<ExternalGenDocHdrDriverLinkContainerModel>>(apiUrl, this.getHttpHeader(visa));
  }
}
